import Router from 'vue-router'
import home from '../components/Home/Home'
import employee from '../components/Employee/Employees-table'
import department from '../components/Department/Departments-table'
import report from '../components/Report/Report'
import reportPrint from '../components/PrintForm/Report-form'

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: home
    },
    {
      path: '/employees',
      component: employee
    },
    {
      path: '/departments',
      component: department
    },
    {
      path: '/reports',
      component: report
    },
    {
      path: '/reports/print',
      component: reportPrint
    }
  ],
  mode: 'history'
})
